import React, { Component } from 'react';
import {
  Divider,
  Grid,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import i18n from '../../i18n';

class SimilarNames extends Component {
  render() {
    const {
      className,
      divider,
      similarNames,
    } = this.props;
    if (!similarNames.length) {
      return (null);
    }
    return (
      <Grid container className={className}>
        <Grid item xs={3}>
          {`${i18n.t('setting:similarExisting')}:`}
        </Grid>
        <Grid item xs={9}>
          {similarNames
            .map(similarName => similarName.target)
            .join(', ')}
        </Grid>
        {divider &&
          <Grid item xs={12}>
            <br />
            <Divider />
            <br />
          </Grid>
        }
      </Grid>
    );
  }
}

SimilarNames.defaultProps = {
  divider: false,
  className: '',
};

SimilarNames.propTypes = {
  similarNames: PropTypes.arrayOf(
    PropTypes.shape({
      target: PropTypes.string,
      rating: PropTypes.number,
    })
  ).isRequired,
  divider: PropTypes.bool,
  className: PropTypes.string,
}

export default SimilarNames;
